// extracted by mini-css-extract-plugin
module.exports = {"test":"testVolume_test__2LCnl"};